import type { IConfirmNicheAction } from './confirm-niche-action.types'
import { ConfirmNicheActionView } from './confirm-niche-action.view'

export const ConfirmNicheAction = (props: IConfirmNicheAction) => {
  return <ConfirmNicheActionView {...props} />
}
